<div class="flex items-center gap-4">
  @for (option of options(); track $index) {
    <app-checkbox
      [value]="option"
      [selectedValues]="value()"
      (click)="handleSelect(option, $event)"
    />
  }
</div>
